import type { ObjectSchema } from 'yup';
import type { SectionConfig } from '../../types';

export function defineSection<
  TKey extends string,
  TClient,
  TSchema extends ObjectSchema<object>,
  TPayload
>(cfg: SectionConfig<TKey, TClient, TSchema, TPayload>) {
  return cfg;
}